import { spacing1_5x } from '@calendly/ui/spacing';
/** Vertical rhythm between preset filter sheet blocks (Figma: 14px). */

/** Figma mobile filter sheet horizontal inset (24px) — content column, not edge-to-edge. */
const presetFilterSheetHorizontalInset = spacing1_5x;
export const PRESET_FILTER_SHEET_HORIZONTAL_INSET = presetFilterSheetHorizontalInset;

// TODO(cui-drift): CUI ViewSwitcher has no Figma border variant — track replacement in #calendly-ui
/** Meetings-Search---Filter segmented control: bordered track + bordered selected segment. */
export const schedulingSourceSwitchFigmaCss = "s1pntj70";

// TODO(cui-drift): CUI ViewSwitcher has no Figma desktop variant — track replacement in #calendly-ui
/**
 * Desktop meetings-page header sizing for the All meetings / Calendly only toggle.
 * Larger Figma type ramp (body-large, taller segments). Kept off the shared base so the
 * full-width mobile/tablet filter-sheet variant stays compact and never overflows/wraps.
 */
export const schedulingSourceSwitchDesktopCss = "s1byzw13";

// TODO(cui-drift): CUI ViewSwitcher has no mobile/Figma variant — track replacement in #calendly-ui
/** Matches Meetings-Search---Filter mobile filter View switcher (40px track, 32px segments). */
export const presetFilterSchedulingSwitchCss = "pqdpoxg";
export const presetFilterSectionHeaderCss = "p89xeyg";

/** Filters section header — 14px below the source divider per Figma. */
export const presetFilterSectionHeaderAfterDividerCss = "psjl081";
export const presetFilterSectionContentCss = "p1wu3lii";

/** Source block: scope + switch, then a content-width divider (14px below toggle). */
export const presetFilterSourceBlockCss = "p4xhxse";
export const presetFilterScopeControlCss = "p1v96ldo";
export const presetFilterScopeSelectCss = "p1uhdov7";

/** Matches presetFilterDropdownTriggerCss — 40px trigger with vertically centered label text. */
export const presetFilterScopeControlSurfaceCss = "p1onwr6p";

/** Shared horizontal inset for preset field labels and controls (matches full-screen scroll padding). */
export const presetFilterFieldContentCss = "pozfcf5";
export const presetFilterFieldLabelCss = "p40bbo5";
export const presetFilterLabelContainerCss = "p1mvu5q7";
export const presetFilterCheckboxContainerCss = "pzt59uj";

/** Checkbox row label — vertically centers caption text with the control on the preset sheet. */
export const presetFilterCheckboxLabelCss = "p755quk";
export const presetFilterFieldItemCss = "p1enptqw";

/** Scroll body wrapper — grows to fill the sheet; horizontal inset is on the shell scroll region. */
export const presetFilterScrollBodyCss = "p1wi9dax";

/** Preset sheet uses a vertical stack instead of the desktop grid row model. */
export const presetFilterGridCss = "p4t6xhg";
export const presetFilterFooterCss = "p1ugpgwf";
export const presetFilterDropdownTriggerCss = "ph4wdym";

require("./preset_filter_sheet_styles.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./preset_filter_sheet_styles.js");